import { render, staticRenderFns } from "./SettlementTypeSelect.vue?vue&type=template&id=503a341d&scoped=true&"
import script from "./SettlementTypeSelect.vue?vue&type=script&lang=js&"
export * from "./SettlementTypeSelect.vue?vue&type=script&lang=js&"
import style0 from "./SettlementTypeSelect.vue?vue&type=style&index=0&id=503a341d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503a341d",
  null
  
)

export default component.exports